'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var TextLink = require('@narvar/nth-bit-text-link');
var nthHookContextPage = require('@narvar/nth-hook-context-page');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var useOrderTracking = require('@narvar/nth-hook-order-tracking');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var utils = require('./utils.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);
var useOrderTracking__default = /*#__PURE__*/_interopDefaultLegacy(useOrderTracking);

const TrackingStatusComponent = ({
  children,
  featureName,
  layout
}) => {
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const {
    state: {
      retailerMoniker,
      orderNumbers,
      claimPortalUrl,
      localeCountry,
      localeLanguage
    }
  } = nthHookContextPage.usePageContext();
  const {
    bodytextDefaultNone,
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  const {
    trackLinkToClaimsPortal,
    trackingStatusHelperText
  } = nthHookTranslations.useTranslations();
  const {
    trackPageAssistPortalLinkEnabled
  } = nthHookGlobalSettings.useGlobalSettings();
  const {
    getCurrentShipment
  } = useOrderTracking__default["default"]();
  const currentShipment = getCurrentShipment();

  // Determine the claimsPortalLink and if it should show
  const claimsPortalLink = trackPageAssistPortalLinkEnabled && claimPortalUrl && currentShipment?.status === 'DELIVERED' ? utils.getClaimsPortalLink(claimPortalUrl, retailerMoniker, orderNumbers?.[0], localeLanguage, localeCountry) : '';
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      marginBottom: '0.75rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.BigHeader, {
    as: "p",
    featureName: featureName
  }, children), trackingStatusHelperText && /*#__PURE__*/React__default["default"].createElement("p", {
    style: {
      marginTop: '0.5rem',
      ...bodytextDefaultNone
    }
  }, trackingStatusHelperText), claimsPortalLink && /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    linkStyle: {
      sDefault: {
        ...linksNoneDefault,
        marginTop: '0.5rem',
        display: 'block'
      },
      sHover: linksNoneHover
    },
    href: claimsPortalLink,
    includeReferrer: true,
    onClick: () => logEvent({
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.ASSIST_PORTAL_LINK,
      clickLinkDestinationUrl: claimsPortalLink,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.ASSIST_PORTAL_LINK,
      clickType: nthHookContextAnalytics.NarvarClickTypes.OUTGOING,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_TRACKING_STATUS,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_EDD_PANEL,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_EDD_PANEL,
      trackLayout: layout
    })
  }, trackLinkToClaimsPortal));
};
const TrackingStatus = ({
  featureName,
  layout
}) => {
  const {
    trackingStatus,
    trackingStatusNoEddTitle,
    trackingStatusScheduleDelivery,
    trackingStatusDeliveryScheduled
  } = nthHookTranslations.useTranslations();
  const {
    getCurrentShipment
  } = useOrderTracking__default["default"]();
  const currentShipment = getCurrentShipment();
  if (!currentShipment) return null;
  const {
    displayDate,
    scheduling
  } = currentShipment;
  if (scheduling?.isSchedulable && !scheduling.isScheduled) {
    return /*#__PURE__*/React__default["default"].createElement(TrackingStatusComponent, {
      featureName: featureName,
      layout: layout
    }, trackingStatusScheduleDelivery);
  }
  if (scheduling?.isScheduled) {
    return /*#__PURE__*/React__default["default"].createElement(TrackingStatusComponent, {
      featureName: featureName,
      layout: layout
    }, trackingStatusDeliveryScheduled);
  }
  if (!displayDate) {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
      as: "p",
      featureName: featureName,
      containerCustomStyle: {
        textTransform: 'uppercase'
      }
    }, trackingStatusNoEddTitle), /*#__PURE__*/React__default["default"].createElement(TrackingStatusComponent, {
      featureName: featureName,
      layout: layout
    }, trackingStatus));
  }
  return /*#__PURE__*/React__default["default"].createElement(TrackingStatusComponent, {
    featureName: featureName,
    layout: layout
  }, trackingStatus);
};
var index = nthHookGlobalSettings.withGlobalSettingsProvider(nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(TrackingStatus, {
  themeTokens: ['bodytextDefaultNone', 'linksNoneDefault', 'linksNoneHover']
}), {
  translationKeys: ['trackingStatus', 'trackingStatusNoEddTitle', 'trackingStatusScheduleDelivery', 'trackingStatusDeliveryScheduled', 'trackingStatusHelperText', 'trackLinkToClaimsPortal']
}), {
  globalSettingsRequested: 'trackPageAssistPortalLinkEnabled'
});

exports["default"] = index;
